import { createSelector } from '@ngrx/store';
import { getAuthenticationState } from '../auth.selectors';
import { State } from '../auth.state';

export const totpConfigured = createSelector(
  getAuthenticationState,
  (state: State) =>
    !state.settingsFlow?.ui?.nodes.find((n) => n.group === 'totp' && n.type === 'img')
);

export const recoveryConfigured = createSelector(
  getAuthenticationState,
  (state: State) =>
    !!state.settingsFlow?.ui?.nodes.find(
      (n) => n.group === 'lookup_secret' && (<any>n.attributes).name === 'lookup_secret_disable'
    )
);
export const getSettingsFlow = createSelector(
  getAuthenticationState,
  (state: State) => state.settingsFlow
);

export const isLoading = createSelector(getAuthenticationState, (state: State) => state.loading);
